import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { QrCargaMensaje } from "./qrCarga/model";
import { LectorQRCargaDescarga } from "./qrCarga/view";
export { QrCargaMensaje };
import * as rx from "rxjs";
import { MetodoCargaDescarga } from "app/models/requireme";

interface CompProps {
    value: string;
    onChange: (x: string) => void;
    onEnter?: () => void | Promise<void>;
    loading?: boolean;
    finalizada?: boolean;
    onQR?: () => void;
}

class FolioFisicoText extends React.PureComponent<CompProps> {
    render() {
        return <kea.Text
            value={this.props.value}
            onChange={this.props.onChange}
            label="Incluir paquete/sobre"
            addon={this.props.loading ? <kea.Spinner /> : <kea.Link iconClass={fa("qrcode")} disabled={this.props.finalizada} onClick={this.props.onQR} >Escanear QR</kea.Link>}
            style={{ fontFamily: "monospace" }}
            onEnter={this.props.onEnter}
            readonly={this.props.finalizada}
            error={this.props.finalizada ? "Finalizado" : false}
            disableFastInput={true}
        />;
    }
}

export const FolioFisicoTextRX = componentToRx(FolioFisicoText);

export interface Props {
    onLectura: (x: string, metodo: MetodoCargaDescarga) => void | Promise<void>;
    mensaje: rx.Observable<QrCargaMensaje> | QrCargaMensaje;
    finalizado: rx.Observable<boolean> | boolean;
    /**True para permitir teclear el valor, falso para sólo poder escanear con el celular */
    permiteTeclear: boolean;
}

function beep(x: number) {
    const nav = navigator as any;
    if (nav.notification)
        nav.notification.beep(x);
}


/**Emite un evento cada vez que se lee un folio físico */
 class FolioFisicoNoRx extends React.PureComponent<Props, {
    folio: string,
    loading: boolean;
    qr: boolean;
}> {
    constructor(props) {
        super(props);

        this.state = { folio: "", loading: false, qr: false };
    }

    onChange = (x: string) => {
        this.setState({ folio: x });
    }

    onLeerQR = async (x: string) => {
        beep(1);
        navigator.vibrate(250);
        await this.props.onLectura(x, MetodoCargaDescarga.QR);
    }

    onEnter = async () => {
        const folio = this.state.folio.trim().toUpperCase();
        const folioRegex = /[A-Z,0-9]{3}-[0-9]{4};(?:P|S)[1-9][0-9]*/;
        if (!folioRegex.test(folio)) {
            await kea.message("Folio incorrecto", "Asegurese de haber escaneado el folio de un paquete o sobre", "error");
        } else {
            try {
                await new Promise(resolve => this.setState({ loading: true }, resolve));
                beep(1);
                navigator.vibrate(250);
                await this.props.onLectura(folio, MetodoCargaDescarga.Manual);
            } catch (error) {
                throw error;
            } finally {
                this.setState({ folio: "", loading: false });
            }
        }
    }

    onQR = () => this.setState({ qr: true });

    render() {
        return (
            <div>
                {
                    this.props.permiteTeclear ?
                        <FolioFisicoTextRX
                            value={this.state.folio}
                            onChange={this.onChange}
                            onEnter={this.onEnter}
                            loading={this.state.loading}
                            onQR={this.onQR}
                            finalizada={this.props.finalizado}
                        /> :
                        <kea.Button iconClass={fa("qrcode")} disabled={this.props.finalizado} onClick={this.onQR} >Escanear QR</kea.Button>
                }
                {
                    this.state.qr &&
                    <LectorQRCargaDescarga
                        mensaje={this.props.mensaje}
                        onLectura={this.onLeerQR}
                        onClose={() => this.setState({ qr: false })}
                    />
                }
            </div>
        );
    }
}


export const FolioFisico = componentToRx<Props>(FolioFisicoNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/foliofisico.tsx